import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-label',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.css']
})
export class LabelComponent implements OnInit {
  @Input('testReport') testdata: any = {}

  constructor() { }

  ngOnInit(): void {
    console.log(this.testdata,"testdata")
  }

}
